import {
  meterFrameOpenformModalConfig
} from '@shared/modals/meterframe/meterframe-openform/meterframe-openform.modal-config';
import { ModalConfig } from '@shared/interfaces/modal/modal-config';

export const meterframeOpenformEditModalConfig: ModalConfig = {
  ...meterFrameOpenformModalConfig,
  title: 'meterFrame.edit.title',
  actions: [
    {
      type: 'primary',
      label: 'system.button.save',
      method: 'saveChanges'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
